import React from 'react';
import { CalcitePanel } from "@esri/calcite-components-react";


const TestPage = () => {

	return ( <CalcitePanel slot="center-row">My Content</CalcitePanel> );
}


export default TestPage;